import { Control, Controller, FieldErrors } from 'react-hook-form';

import { FilterSelect } from '@/components/shared/FilterSelect/FilterSelect';

import { CONTENT_STATUS, SUPPORTED_LANGUAGES } from '../../../const';
import { BlockFormData } from '../schema';

type StatusLanguageFieldsProps = {
  control: Control<BlockFormData>;
  errors: FieldErrors<BlockFormData>;
};

export const StatusLanguageFields = ({ control, errors }: StatusLanguageFieldsProps) => {
  return (
    <div className="flex gap-4 mb-4 items-center flex-wrap">
      <div>
        <Controller
          name="language"
          control={control}
          render={({ field }) => (
            <FilterSelect
              value={field.value as string}
              onChange={(v) => field.onChange(v)}
              className="bg-white-100"
              labelClassName="font-semibold text-neutral-70"
              label="Language"
              options={[
                { value: '', label: 'All Languages' },
                ...SUPPORTED_LANGUAGES.map(({ value, label, icon }) => ({
                  value,
                  label,
                  icon,
                })),
              ]}
            />
          )}
        />
        {errors.language && <p className="mt-1 text-sm text-red-600">{errors.language.message}</p>}
      </div>
      <div>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <FilterSelect
              value={field.value as string}
              onChange={(v) => field.onChange(v)}
              className="bg-white-100"
              labelClassName="font-semibold text-neutral-70"
              label="Status"
              options={[
                { value: '', label: 'All Statuses' },
                ...CONTENT_STATUS.map(({ value, label, icon, color }) => ({
                  value,
                  label,
                  icon,
                  color,
                })),
              ]}
            />
          )}
        />
        {errors.status && <p className="mt-1 text-sm text-red-600">{errors.status.message}</p>}
      </div>

      <div className="flex items-center gap-2">
        <Controller
          name="showFeedback"
          control={control}
          render={({ field }) => (
            <input
              type="checkbox"
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
          )}
        />

        <label className="block text-sm font-semibold text-neutral-70">Show Feedback</label>
      </div>
    </div>
  );
};
